<app-header></app-header>
<!-- <app-toolbar></app-toolbar> -->
<app-breadcrumb></app-breadcrumb>

<ng-content></ng-content>

<app-footer></app-footer>
